import { call, put } from "redux-saga/effects";
import { cncUpdateWOStatus } from "../requests/cncUpdateWOStatus";
import {
  modifyCNCManualWeborderStatusSuccess,
  modifyCNCManualWeborderStatusFailure,
  modifyCNCScannedWeborderStatusSuccess,
  modifyCNCScannedWeborderStatusFailure,
} from "../../cncWebOrder/cncWebOrderActions";
import {
  startLoadingIndicator,
  stopLoadingIndicator,
} from "../../loadingIndicator/loadingIndicatorActions";
import Constants from "../../../Constants";
import patchWeborderReport from "../requests/cncUpdateWOStatusReport";
import { currentDateInApiFormat } from "../../../util/utils";

export function* handleUpdateCNCManualWeborderStatus({
  payload: { woId, woStatus, customerEntry },
}) {
  try {
    yield put(startLoadingIndicator());
    const response = yield call(cncUpdateWOStatus, {
      woId: woId,
      woStatus: woStatus,
      customerEntry,
    });
    const updatedWeborderObj = parseWOStatus(response);
    const uWoStatus =
      updatedWeborderObj.woStatus ?? Constants.webOrderConst.status.NotFound;
    const uWoId = updatedWeborderObj.woId;
    const uWoNo = updatedWeborderObj.woNo;
    const uCustomerEntry = updatedWeborderObj.customerEntry;
    const upickupStoreLocation = updatedWeborderObj?.pickupStoreLocation;

    yield call(patchWeborderReport, {
      customerArrivedDt: currentDateInApiFormat(),
      ccStatus: Constants.webOrderConst.status.CustomerArrived,
      woNo: uWoNo,
      customer_entry: uCustomerEntry,
      pickupStoreLocation: upickupStoreLocation,
    });

    yield put(
      modifyCNCManualWeborderStatusSuccess({
        woStatus: uWoStatus,
        woId: uWoId,
        woNo: uWoNo,
        customerEntry: uCustomerEntry,
        pickup_store_location: upickupStoreLocation,
      })
    );

    yield put(stopLoadingIndicator());
  } catch (error) {
    console.log(`handleUpdateCNCManualWeborderStatus error = ${error}`);
    yield put(modifyCNCManualWeborderStatusFailure({ error }));
    yield put(stopLoadingIndicator());
  }
}

export function* handleUpdateCNCScannedWeborderStatus({
  payload: { woId, woStatus, customerEntry },
}) {
  try {
    yield put(startLoadingIndicator());
    const response = yield call(cncUpdateWOStatus, {
      woId: woId,
      woStatus: woStatus,
      customerEntry,
    });
    const updatedWeborderObj = parseWOStatus(response);
    const uWoStatus =
      updatedWeborderObj.woStatus ?? Constants.webOrderConst.status.NotFound;
    const uWoId = updatedWeborderObj.woId;
    const uWoNo = updatedWeborderObj.woNo;
    const uCustomerEntry = updatedWeborderObj.customerEntry;
    const upickupStoreLocation = updatedWeborderObj?.pickupStoreLocation;

    yield call(patchWeborderReport, {
      customerArrivedDt: currentDateInApiFormat(),
      ccStatus: Constants.webOrderConst.status.CustomerArrived,
      woNo: uWoNo,
      customer_entry: uCustomerEntry,
      pickupStoreLocation: upickupStoreLocation,
    });

    yield put(
      modifyCNCScannedWeborderStatusSuccess({
        woStatus: uWoStatus,
        woId: uWoId,
        woNo: uWoNo,
        customerEntry: uCustomerEntry,
        pickup_store_location: upickupStoreLocation,
      })
    );

    yield put(stopLoadingIndicator());
  } catch (error) {
    console.log(`handleFetchCNCScannedWeborderStatus error = ${error}`);
    yield put(modifyCNCScannedWeborderStatusFailure({ error }));
    yield put(stopLoadingIndicator());
  }
}

const parseWOStatus = (resp) => ({
  woId: resp?.data?.data?.id,
  woNo: resp?.data?.data?.document_no,
  pickupStoreLocation: resp?.data?.data?.pickup_store_location,
  woStatus:
    resp?.data?.data?.cc_status ?? Constants.webOrderConst.status.NotFound,
  customerEntry:
    resp?.data?.data?.customer_entry ??
    process.env.REACT_APP_CC_CUSTOMER_ENTRTY,
});
